import { render, staticRenderFns } from "./BasketItemConsentCheck.vue?vue&type=template&id=885dbfde"
import script from "./BasketItemConsentCheck.vue?vue&type=script&lang=js"
export * from "./BasketItemConsentCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports